import { Tag } from '@chakra-ui/react'

import Tippy from '@/components/UI/Tippy'

export default function PointsTag({
  points,
  tooltip = null,
}: {
  points: number
  tooltip?: string | null
}): React.ReactElement {
  const tag = (
    <Tag color="orange.fg" bg="yellow.subtle" whiteSpace="nowrap">
      +{points} SP
    </Tag>
  )
  return tooltip == null ? tag : <Tippy content={tooltip}>{tag}</Tippy>
}
